import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function ChallengeTranslateContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey={
        status === "success"
          ? "notifications.challengeTranslatedSuccess"
          : status === "pending"
            ? "notifications.challengeTranslated"
            : "notifications.challengeTranslatedFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
